import React, { Component } from "react";
import Global from "../../../../Global";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Pagination, Autoplay } from "swiper";
import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";
import "swiper/components/pagination/pagination.min.css";
import PopularOffersItem from "./PopularOffersItem";
import "./PopularOffers.css";

SwiperCore.use([Autoplay]);


class PopularOffers extends Component {
  constructor(props) {
    super(props);

    this.state = {
      popularOffers: null,
    };
  }

  componentWillMount() {
    var url = Global.getAPI("home-popular-offers");
    var self = this;
    fetch(url)
      .then(function(response) {
        if (response.status >= 400) {
          throw new Error("Error API: home-popular-offers");
        }
        return response.json();
      })
      .then(function(data) {
        self.setState({
          popularOffers: data.popularOffers,
        });
      });
  }

  render() {
    const { popularOffers } = this.state;

    if (popularOffers === null) return null;

    return (
      <div className="container-popular-offers">
        <Swiper
          className="popular-offers-swiper"
          modules={[Pagination,Autoplay]}
          style={{
            "--swiper-pagination-color": "#7852E2",
          }}
          keyboard
          watchOverflow
          loop={true}
          allowTouchMove={popularOffers.length > 1}
          autoplay={popularOffers.length > 1 ? {
              "delay": 5000,
              "disableOnInteraction": false,
              "pauseOnMouseEnter": false,
              "stopOnLastSlide": false,
              "waitForTransition": true
          }: false}
          centeredSlides={false}
          observeParents={true}
          pagination={{
            clickable: true,
          }}
        >
          {popularOffers.map((offer, i) => (
            <SwiperSlide key={`popular-offers-item-${i + 1}`}>
              <PopularOffersItem offer={offer} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    );
  }
}

export default PopularOffers;
